import MrtCaseTemplatesTable from "@/components/Table/MrtCaseTemplatesTable.tsx";
import MrtTaskTemplatesTable from "@/components/Table/MrtTaskTemplatesTable.tsx";
import { Stack, Typography } from "@mui/material";
import { type ReactNode, useEffect } from "react";
import { Outlet } from "react-router-dom";

const TemplatesPage = (): ReactNode => {
    useEffect(() => {
        document.title = "Templates";
    }, []);

    return (
        <>
            <Stack
                sx={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                }}
            >
                <Typography variant="h4" mb={2}>
                    Case Templates
                </Typography>
            </Stack>

            <MrtCaseTemplatesTable />

            <Stack
                sx={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                    mt: 4,
                }}
            >
                <Typography variant="h4" mb={2}>
                    Task Templates
                </Typography>
            </Stack>
            <MrtTaskTemplatesTable />
            <Outlet />
        </>
    );
};

export default TemplatesPage;
